/* The event featured in blue-2's "come say hi!" section. Facts match the
   /events/stitches-night-out page. */
/** The morning after the event (Denver time); event promos hide from then. */
export const EVENT_ENDS = new Date("2026-10-21T06:00:00Z");

export const EVENT = {
  href: "/blue-2/events/stitches-night-out", // the blue-2 version; the original stays at /events/stitches-night-out
  title: "Stitches Night Out",
  tagline: "A sewists’ movie night",
  kicker: "Halloween movie night",
  // Headline, in Title Case: "Watch " + <i>film</i> + " & Craft With Me!"
  headline: ["Watch", "& Craft With Me!"] as const,
  blurb: "Hand crafts, new friends, prizes, and Practical Magic 2.",
  film: "Practical Magic 2",
  weekday: "Tue", month: "Oct", day: "20", time: "6:30 PM",
  venue: "American Fork Cinemark", city: "American Fork, UT",
  price: "$25",
  poster: "/events/practical-magic-2.jpg", // 1080 × 1350
  posterAlt: "Practical Magic 2 movie poster featuring Sandra Bullock and Nicole Kidman in warm candlelight",
};
